// components/PopularBlogsSkeleton.jsx
import React from "react";

const PopularBlogsSkeleton = ({ count }) => {
  return (
    <div className="d-flex flex-column gap-lg-4 gap-4">
      {[...Array(count)].map((_, index) => (
        <div key={index} className="blog-maincard">
          <div className="blog-cardimgDiv">
            <div className="skeleton skeleton-img" />
            <span className="skeleton skeleton-date" />
          </div>
          <div className="blogcard-content">
            <div className="skeleton skeleton-category" />
            <div className="skeleton skeleton-title" />
            <div className="skeleton skeleton-description" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default PopularBlogsSkeleton;
